import dayjs from 'dayjs';
import {
  BusinessHourApiResponse,
  SchedulerEventType,
  AppointmentAvailabilityCheckResponse,
  SchedulerFormikType,
  EditSchedulerEventType,
  OptionType,
  Client,
} from '../utils/type';
import { ApiMessage, ApiResponseHandler } from './ApiResponseHandler';
import ThomApiClient from './ThomApiClient';
import { getCurrentWeekSundayAsDate } from '../utils/utilities';
import {
  Employee
 
} from '../services/configApi/employees/employeeServices'; 
type MultiSelectOptioinType = Employee | Client;

export const getSchedulerEventDetailsById = async (
  eventId: string,
): Promise<SchedulerEventType> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get(
      `appointment?appointmentId=${eventId}`,
    ),
  );
};

export const getOwnerEventDetailsById = async (
  commonAppointmentId: string,
  employeeId: string,
): Promise<SchedulerEventType> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get(
      `/appointment/multiple-attendees?commonAppointmentId=${commonAppointmentId}&employeeId=${employeeId}`,
    ),
  );
};

export const getBusinessHoursOfEmployee = async (
  employeeId: string,
  sundayDateinISO: string,
): Promise<BusinessHourApiResponse> => {
  const timezone = encodeURIComponent(
    dayjs(getCurrentWeekSundayAsDate()).format('Z'),
  );
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get(
      `appointment/business-hours?employeeId=${employeeId}&startDateTime=${sundayDateinISO}&timezone=${timezone}`,
    ),
  );
};

export interface SchedulerResponse {
  eventResponse: SchedulerEventType[];
  count: number | null;
}

export const getAllSchedulerEvents = async (
  employeeId: string | null | undefined,
  start: string,
  end: string,
  calendarUnit: string | null,
  schedulerType: string,
  selectedAppointmentTypes: OptionType[],
  selectedClientFilter: string,
  selectedClient: MultiSelectOptioinType[] | null,
  page: number,
): Promise<SchedulerResponse> => {
  const timezone = encodeURIComponent(
    dayjs(getCurrentWeekSundayAsDate()).format('Z'),
  );
  let url = '';
  if (schedulerType === 'programschedule') {
    let filterApi: string = '';
    if (employeeId && employeeId !== null) {
      filterApi = filterApi.concat(`&employeeId=${employeeId}`);
    }
    if (selectedAppointmentTypes && selectedAppointmentTypes.length > 0) {
      filterApi = filterApi.concat(
        `&appointmentType=${selectedAppointmentTypes
          .map((item) => item.id)
          .join(',')}`,
      );
    }
    if (selectedClientFilter && selectedClientFilter !== null) {
      filterApi = filterApi.concat(
        `&withClients=${selectedClientFilter === 'all'}`,
      );
    }
    if (selectedClient && selectedClient.length > 0) {
      filterApi = filterApi.concat(
        `&clientIds=${selectedClient.map((item) => item.clientId).join(',')}`,
      );
    }

    url = `appointment/program/list?start=${start}&end=${end}&timezone=${timezone}${filterApi}&page=${page}&size=10`;
  } else {
    url = `appointment/list?employeeId=${employeeId}&start=${start}&end=${end}&timezone=${timezone}&calendarUnit=${calendarUnit}`;
  }
  return ApiResponseHandler(await ThomApiClient.getInstance().get(url));
};

export const addAppointment = async (
  params: SchedulerFormikType,
): Promise<ApiMessage> => {
  const timezone = encodeURIComponent(dayjs(new Date()).format('Z'));
  return ApiResponseHandler(
    await ThomApiClient.getInstance().post<SchedulerFormikType, ApiMessage>(
      `appointment?timezone=${timezone}`,
      params,
    ),
  );
};

export const checkAvailability = async (
  params: SchedulerFormikType | EditSchedulerEventType,
  appointmentId: string,
): Promise<AppointmentAvailabilityCheckResponse> => {
  const timezone = encodeURIComponent(dayjs().format('Z'));
  if (appointmentId == '') {
    return ApiResponseHandler(
      await ThomApiClient.getInstance().post<
        SchedulerFormikType | EditSchedulerEventType,
        AppointmentAvailabilityCheckResponse
      >(
        `appointment/availability-check?timezone=${timezone}`,
        params,
      ),
    );
  } else {
    return ApiResponseHandler(
      await ThomApiClient.getInstance().post<
        SchedulerFormikType | EditSchedulerEventType,
        AppointmentAvailabilityCheckResponse
      >(
        `appointment/availability-check?appointmentId=${appointmentId}&timezone=${timezone}`,
        params,
      ),
    );
  }
};

export const editAppointment = async (
  params: EditSchedulerEventType,
  updateType: string,
): Promise<ApiMessage> => {
  const timezone = encodeURIComponent(dayjs(new Date()).format('Z'));
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put<EditSchedulerEventType, ApiMessage>(
      `appointment?timezone=${timezone}&updateType=${updateType}`,
      params,
    ),
  );
};

export const deleteAppointment = async (
  userId: string,
  attendeeId: string,
  appointmentId: string,
  deleteOption: string,
): Promise<ApiMessage> => {
  const timezone = encodeURIComponent(dayjs(new Date()).format('Z'));
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `appointment?attendeeId=${attendeeId}&deleteOption=${deleteOption}&appointmentId=${appointmentId}&timezone=${timezone}&employeeId=${userId}`,
    ),
  );
};

export const deleteEvent = async (
  Id: string,
  deleteOption: string,
): Promise<ApiMessage> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `appointment?deleteOption=${deleteOption}&appointmentId=${Id}`,
    ),
  );
};
